export const ESCALATION_GROUP_GET_REQUEST = "ESCALATION_GROUP_GET_REQUEST";
export const ESCALATION_GROUP_GET_SUCCESS = "ESCALATION_GROUP_GET_SUCCESS";
export const ESCALATION_GROUP_GET_FAILURE = "ESCALATION_GROUP_GET_FAILURE";

export const ESCALATION_GROUP_FIND_REQUEST = "ESCALATION_GROUP_FIND_REQUEST";
export const ESCALATION_GROUP_FIND_SUCCESS = "ESCALATION_GROUP_FIND_SUCCESS";
export const ESCALATION_GROUP_FIND_FAILURE = "ESCALATION_GROUP_FIND_FAILURE";

export const ESCALATION_GROUP_ACTION_REQUEST = "ESCALATION_GROUP_ACTION_REQUEST";
export const ESCALATION_GROUP_ACTION_SUCCESS = "ESCALATION_GROUP_ACTION_SUCCESS";
export const ESCALATION_GROUP_ACTION_FAILURE = "ESCALATION_GROUP_ACTION_FAILURE";


